/*----------------------
        LOGOS 
---------------------- */

logosSlider = {
    init: function () {
        new Swiper('.swiper--logos', {
            slidesPerView: "auto",
            loop: true,
            freeMode: true,
            speed:5000,
            allowTouchMove: false,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
        });
    }
};


$(function () {
    logosSlider.init();
});